/*
 * @Description: 消息通知相关
 * @Author: ljrong
 * @Date: 2024-03-14 13:54:27
 * @LastEditTime: 2024-07-31 16:59:46
 */
import { post } from '@/utils/request'

// 获取用户动态列表
export function getUserFeedTimelineList<T>(data: {
  page?: number
  pageSize?: number
  enterpriseId?: number
  hasShow?: number // 是否显示 0：不显示 1：显示
}) {
  // return new Promise((resolve, reject) => {
  //   setTimeout(() => {

  //     post<T>({
  //       url: '/assistant/feed/system/userFeedTimelineList',
  //       data,
  //     }).then((res) => {
  //       resolve(res)
  //     }).catch((error) => {
  //       reject(error)
  //     })
  //   }, 20000)
  // })
  return post<T>({
    url: '/assistant/feed/system/userFeedTimelineList',
    data,
  })
}

// 获取动态未读数量  readType 类型:0：系统类型，1:所有非系统类型（默认），-1:所有
export function getFeedNotReadCountByCategory<T>(data: { enterpriseId: number; archiveId?: number; readType?: number }) {
  const params = {
    ...data,
    // readType: -1,
  }
  return post<T>({
    url: '/assistant/feed/getFeedNotReadCountByCategory',
    data: params
  })
}


// 设置已读
export function setRead<T>(data: { ids: number[] }) {
  return post<T>({
    url: '/assistant/feed/read',
    data,
  })
}

// 统计
export function getStats<T>(data: {
  enterpriseId?: number
}) {
  return post<T>({
    url: '/assistant/lib/stats',
    data,
  })
}

// 动态 - 空间下所有
export function getSystemFeedTimelineList<T>(data: {
  category: number
  beginTime?: string
  endTime?: string
  enterpriseId: number
  page: number
  pageSize: number
}) {
  return post<T>({
    url: '/assistant/feed/system/userFeedTimelineList',
    data,
  })
}

// 审核加入企业带权限的申请
export function applyEnterpriseReviewHasPermissions<T>(data: {
  applyId: number // 申请记录ID
  code: number // 审核状态码 1：通过 2：拒绝
  enterpriseId: number
  keyword?: string // 搜索成员手机/昵称
  memberId: number // 添加的成员ID
  permissions: number[] // 拥有的权限 1：管理知识库 2：创建产品
}) {
  return post<T>({
    url: '/assistant/enterprise/apply/reviewHasPermissions',
    data,
  })
}

// 审核加入企业的申请
export function reviewJoinCompanyApply(data: {
  enterpriseId: number // 企业id
  code: number // 审核状态码
  applyId: number // 申请记录ID
}) {
  return post({
    url: '/assistant/enterprise/apply/review',
    data,
  })
}

// 同意加入企业产品带权限的申请
export function archiveReviewHasPermissions<T>(data: {
  applyId: number // 申请记录ID
  archiveId: number // 企业产品ID
  code: number // 审核状态码 1：通过 2：拒绝
  enterpriseId: number
  memberId: number // 成员ID
  role: number // 角色：1:编辑成员、2:普通成员
}) {
  return post<T>({
    url: '/assistant/enterprise/apply/archive/reviewHasPermissions',
    data,
  })
}

// 审核加入企业产品的申请
export function reviewJoinCompanyProductApply(data: {
  enterpriseId: number // 企业id
  code: number // 审核状态码
  applyId: number // 申请记录ID
  archiveId: number // 产品id
}) {
  return post({
    url: '/assistant/enterprise/apply/archive/review',
    data,
  })
}


